import { CameraOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Row, Upload } from "antd";
import {
  RcFile,
  UploadChangeParam,
  UploadFile,
} from "antd/lib/upload/interface";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ButtonProps } from "../../helpers/constants";
import { removeSpacesFromString } from "../../helpers/strings";
import { authTokenString, baseURL } from "../../hooks/useAxiosPost";
import useMultiNotification from "../../hooks/useNotification";
import NetwalaButton from "../Items/Button/Index";
import NetwalaSelect from "../Items/Select/Index";
import NetwalaMultiSelect from "../Items/Select/MultiSelect";
import PlusIcon from "./../../assets/svgs/IconsWhite/PlusIcon.svg";
import TailSpinLoader from "../Items/Loaders/TailSpinLoader";
import { Radio } from "antd";
import useAxiosPost from "../../hooks/useAxiosPost";
import { useEffect } from "react";

const CreateStaffForm = () => {
  const { openNotification, contextHolder } = useMultiNotification();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const onFinish = (values: any) => {
    handleCreateStaff(values);
  };
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [fileListBack, setFileListBack] = useState<UploadFile[]>([]);
  const [role, setRole] = useState("");
  const [profilePictureList, setProfilePictureList] = useState<UploadFile[]>(
    []
  );
  const [staffAreaLimitType, setStaffAreaLimitType] = useState<
    "AREA_WISE" | "COMPANY_WISE"
  >("COMPANY_WISE");
  const [selectedAreas, setSelectedAreas] = useState<(string | number)[]>([]);
  const [availableAreas, setAvailableAreas] = useState<NetwalaSelectOptions[]>(
    []
  );

  const [getAreasApi, areasApiResponse, areasApiError, areasApiLoading] =
    useAxiosPost<ResponseProp>("areas/getAreasByOwner");

  useEffect(() => {
    if (staffAreaLimitType === "AREA_WISE") {
      getAreasApi({});
    }
  }, [staffAreaLimitType]);

  useEffect(() => {
    if (areasApiResponse !== null) {
      const data: any = areasApiResponse.responseData;
      const areas = data.map((item: Area): NetwalaSelectOptions => {
        return {
          value: item.intPkAreaID,
          label: item.areaName,
        };
      });
      setAvailableAreas(areas);
    }
  }, [areasApiResponse]);

  const handleRemoveProfile = (file: UploadFile) => {
    setProfilePictureList((prevList) =>
      prevList.filter((item) => item.uid !== file.uid)
    );
  };

  const handleBeforeUploadProfile = (file: RcFile, fileList: RcFile[]) => {
    setProfilePictureList(
      fileList.map((file) => ({
        uid: file.uid,
        name: file.name,
        status: "done",
      }))
    );
    // You can add your upload logic here if needed
    return false; // Return false here to avoid auto uploading
  };

  const handleChangeProfile = (info: UploadChangeParam) => {
    setProfilePictureList(info.fileList);
  };

  const handleRemove = (file: UploadFile) => {
    setFileList((prevList) => prevList.filter((item) => item.uid !== file.uid));
  };

  const handleBeforeUpload = (file: RcFile, fileList: RcFile[]) => {
    setFileList(
      fileList.map((file) => ({
        uid: file.uid,
        name: file.name,
        status: "done",
      }))
    );
    // You can add your upload logic here if needed
    return false; // Return false here to avoid auto uploading
  };

  const handleChange = (info: UploadChangeParam) => {
    setFileList(info.fileList);
  };
  const handleRemoveBack = (file: UploadFile) => {
    setFileListBack((prevList) =>
      prevList.filter((item) => item.uid !== file.uid)
    );
  };

  const handleBeforeUploadBack = (file: RcFile, fileList: RcFile[]) => {
    setFileListBack(
      fileList.map((file) => ({
        uid: file.uid,
        name: file.name,
        status: "done",
      }))
    );
    // You can add your upload logic here if needed
    return false; // Return false here to avoid auto uploading
  };

  const handleChangeBack = (info: UploadChangeParam) => {
    setFileListBack(info.fileList);
  };
  const onFinishFailed = (errorInfo: any) => {};

  const handleCreateStaff = async (values: any) => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("authTokenString", authTokenString.toString());
    formData.append("address", values.address);
    formData.append("designation", values.designation);
    formData.append("firstName", values.firstName);
    formData.append("lastName", values.lastName);
    formData.append("nicNumber", "rightNowStatic");
    formData.append("password", values.password);
    formData.append("phoneNumber", values.phoneNumber);
    // Only send wallet fields for RMAN and CASHIER
    if (values.designation === "RMAN" || values.designation === "CASHIER") {
      formData.append("walletDays", values.walletDays || 1);
      formData.append("walletLimit", values.walletLimit || 1);
    }
    formData.append(
      "staffUserName",
      removeSpacesFromString(values.staffUserName)
    );
    if (values.staffAreaLimitType) {
      formData.append("staffAreaLimitType", values.staffAreaLimitType);
      if (
        values.staffAreaLimitType === "AREA_WISE" &&
        values.areaIds &&
        values.areaIds.length > 0
      ) {
        // Send as JSON string for FormData
        formData.append("areaIds", JSON.stringify(values.areaIds));
      }
    }

    if (fileList.length > 0) {
      formData.append("idCardFront", fileList[0].originFileObj as Blob);
    }
    if (fileListBack.length > 0) {
      formData.append("idCardBack", fileListBack[0].originFileObj as Blob);
    }
    if (profilePictureList.length > 0) {
      formData.append(
        "profilePicture",
        profilePictureList[0].originFileObj as Blob
      );
    }
    try {
      const response = await fetch(`${baseURL}/auth/SignUpStaff`, {
        method: "POST",
        body: formData,
        // Note: When using FormData, do NOT set the Content-Type header
        // The browser will set it automatically, including the boundary parameter
      });

      if (response.ok) {
        const responseData = await response.json();
        openNotification(
          "success",
          "Success",
          responseData?.message || "Staff Created Successfully"
        );
        setTimeout(() => {
          navigate(`/staff`);
        }, 3000);
      } else {
        const responseData = await response.json();
        setIsLoading(false);

        openNotification(
          "error",
          "Operation Failed",
          responseData?.message || "Server Error"
        );
        console.error("Upload failed:", responseData);
      }
    } catch (error) {
      setIsLoading(false);

      console.error("Error during fetch:", error);
    }
  };

  return (
    <>
      {contextHolder}

      {isLoading ? (
        <Row style={{ width: "100%" }}>
          <Col span={24}>
            <TailSpinLoader />
          </Col>
        </Row>
      ) : (
        <Row style={{ width: "100%" }}>
          <Form
            name="createStaffForm"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            layout="vertical"
            requiredMark={false}
            style={{ width: "100%" }}
            form={form}
          >
            {/* First */}
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label={
                    <span className="create-user-form-label">First Name</span>
                  }
                  name="firstName"
                  rules={[
                    {
                      required: true,
                      message: "Please enter First Name",
                    },
                    {
                      validator: (_, value) => {
                        if (value) {
                          if (value.includes("'")) {
                            return Promise.reject(
                              "First Name cannot contain single quote (') character"
                            );
                          }
                          if (value.includes("--")) {
                            return Promise.reject(
                              "First Name cannot contain (--) pattern "
                            );
                          }
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input
                    className="user-input-general-height"
                    placeholder="John"
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label={
                    <span className="create-user-form-label">Last Name</span>
                  }
                  name="lastName"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Last Name",
                    },
                    {
                      validator: (_, value) => {
                        if (value) {
                          if (value.includes("'")) {
                            return Promise.reject(
                              "Last Name cannot contain single quote (') character"
                            );
                          }
                          if (value.includes("--")) {
                            return Promise.reject(
                              "Last Name cannot contain (--) pattern "
                            );
                          }
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input
                    className="user-input-general-height"
                    placeholder="Deo"
                  />
                </Form.Item>
              </Col>
            </Row>
            {/* Second */}
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label={
                    <span className="create-user-form-label">Phone Number</span>
                  }
                  name="phoneNumber"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Phone Number",
                    },
                    {
                      pattern: /^(?:\+92|0)?3[0-9]{9}$/,
                      message: "Please enter a valid Pakistani phone number",
                    },
                  ]}
                >
                  <Input
                    className="user-input-general-height"
                    placeholder="03001234567"
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label={
                    <span className="create-user-form-label">Username</span>
                  }
                  name="staffUserName"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Staff Username",
                    },
                  ]}
                >
                  <Input
                    className="user-input-general-height"
                    placeholder="johndoe1"
                  />
                </Form.Item>
              </Col>
            </Row>
            {/* Third */}
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label={
                    <span className="create-user-form-label">Password</span>
                  }
                  name="password"
                  validateTrigger="onBlur"
                  getValueFromEvent={(e) => e.target.value.trimStart()} // prevent leading spaces
                  rules={[
                    {
                      required: true,
                      message: "Please enter Password",
                    },
                    {
                      min: 6,
                      message: "Password must have minimum of 6 characters",
                    },
                    {
                      validator: (_, value) => {
                        if (!value || value.trim().length === 0) {
                          return Promise.resolve(); // Let required rule handle empty values
                        }

                        // Must contain at least one letter
                        if (!/[a-zA-Z]/.test(value)) {
                          return Promise.reject(
                            "Password must have at least one letter and one number"
                          );
                        }

                        // Must contain at least one number
                        if (!/[0-9]/.test(value)) {
                          return Promise.reject(
                            "Password must have at least one letter and one number"
                          );
                        }

                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input
                    className="user-input-general-height"
                    placeholder="Password"
                    onBlur={(e) => {
                      e.target.value = e.target.value.trim(); // remove trailing spaces when done typing
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label={
                    <span className="create-user-form-label">Address</span>
                  }
                  name="address"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Address",
                    },
                    {
                      validator: (_, value) => {
                        if (value) {
                          if (value.includes("'")) {
                            return Promise.reject(
                              "Address cannot contain single quote (') character"
                            );
                          }
                          if (value.includes("--")) {
                            return Promise.reject(
                              "Address cannot contain (--) pattern "
                            );
                          }
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input
                    className="user-input-general-height"
                    placeholder="House No."
                  />
                </Form.Item>
              </Col>
              {/* <Col span={12}>
              <Form.Item
                label={
                  <span className="create-user-form-label">CNIC Number</span>
                }
                name="nicNumber"
                rules={[
                  {
                    required: true,
                    message: "Please enter CNIC Number",
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="03001234567"
                />
              </Form.Item>
            </Col> */}
            </Row>
            {/* Fourth */}

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label={
                    <span className="create-user-form-label">Designation</span>
                  }
                  name="designation"
                  rules={[
                    {
                      required: true,
                      message: "Please enter First Name",
                    },
                  ]}
                >
                  <NetwalaSelect
                    size="large"
                    height="45px"
                    onChange={(e) => {
                      setRole(e);
                    }}
                    options={[
                      { value: "CASHIER", label: "CASHIER" },
                      { value: "RMAN", label: "RMAN" },
                      // { value: "SALESMAN", label: "SALESMAN" },
                      { value: "PANEL_MANAGER", label: "PANEL_MANAGER" },
                      { value: "LINEMAN", label: "LINEMAN" },
                    ]}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label={
                    <span className="create-user-form-label">User Profile</span>
                  }
                  name="userProfile"
                >
                  <Upload
                    onRemove={handleRemoveProfile}
                    beforeUpload={handleBeforeUploadProfile}
                    onChange={handleChangeProfile}
                    fileList={profilePictureList}
                  >
                    <Button icon={<CameraOutlined />}>Upload Pic</Button>
                  </Upload>
                </Form.Item>
              </Col>
            </Row>
            {/* Fifth */}
            {(role === "RMAN" || role === "CASHIER") && (
              <>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      label={
                        <span className="create-user-form-label">
                          Wallet Limit
                        </span>
                      }
                      name="walletLimit"
                      rules={[
                        {
                          required: true,
                          message: "Please enter Wallet Limit",
                        },
                        {
                          validator: (_, value) =>
                            value > 0
                              ? Promise.resolve()
                              : Promise.reject(
                                  new Error(
                                    "Wallet Limit Must be greater than 0"
                                  )
                                ),
                        },
                      ]}
                    >
                      <Input
                        type="number"
                        className="user-input-general-height"
                        placeholder="50000"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label={
                        <span className="create-user-form-label">
                          Wallet Days
                        </span>
                      }
                      name="walletDays"
                      rules={[
                        {
                          required: true,
                          message: "Please enter Wallet Days",
                        },
                        {
                          validator: (_, value) =>
                            value > 0
                              ? Promise.resolve()
                              : Promise.reject(
                                  new Error(
                                    "Wallet Days Must be greater than 0"
                                  )
                                ),
                        },
                      ]}
                    >
                      <Input
                        type="number"
                        className="user-input-general-height"
                        placeholder="7"
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}
            {/* Connection View Type - for RMAN, CASHIER, and LINEMAN */}
            {(role === "RMAN" || role === "CASHIER" || role === "LINEMAN") && (
              <>
                <Row gutter={16}>
                  <Col span={24}>
                    <Form.Item
                      label={
                        <span className="create-user-form-label">
                          Connection View Type
                        </span>
                      }
                      name="staffAreaLimitType"
                      initialValue="COMPANY_WISE"
                      rules={[
                        {
                          required: true,
                          message: "Please select Connection View Type",
                        },
                      ]}
                    >
                      <Radio.Group
                        onChange={(e) => {
                          setStaffAreaLimitType(e.target.value);
                          if (e.target.value === "COMPANY_WISE") {
                            setSelectedAreas([]);
                            form.setFieldsValue({ areaIds: [] });
                          }
                        }}
                      >
                        <Radio value="COMPANY_WISE">
                          Company Wise - View all company connections
                        </Radio>
                        <Radio value="AREA_WISE">
                          Area Wise - View only assigned area connections
                        </Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                </Row>
                {staffAreaLimitType === "AREA_WISE" && (
                  <Row gutter={16}>
                    <Col span={24}>
                      <Form.Item
                        label={
                          <span className="create-user-form-label">
                            Assign Areas
                          </span>
                        }
                        name="areaIds"
                        dependencies={["staffAreaLimitType"]}
                        rules={[
                          {
                            required: staffAreaLimitType === "AREA_WISE",
                            message: "Please select at least one area",
                          },
                          {
                            validator: (_, value) => {
                              const currentType =
                                form.getFieldValue("staffAreaLimitType");
                              if (
                                currentType === "AREA_WISE" &&
                                (!value || value.length === 0)
                              ) {
                                return Promise.reject(
                                  new Error("Please select at least one area")
                                );
                              }
                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <NetwalaMultiSelect
                          showSearch={true}
                          value={selectedAreas}
                          onChange={(value) => {
                            setSelectedAreas(value);
                            form.setFieldsValue({ areaIds: value });
                          }}
                          height="45px"
                          options={availableAreas}
                          placeHolder="Select areas"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                )}
              </>
            )}
            {/* Final */}
            {/* <Row>
            <Col span={12}>
              <Form.Item
                label={
                  <span className="create-user-form-label">
                    ID Card (Front)
                  </span>
                }
                name="idCardFront"
              >
                <Upload
                  onRemove={handleRemove}
                  beforeUpload={handleBeforeUpload}
                  onChange={handleChange}
                  fileList={fileList}
                >
                  <Button icon={<CameraOutlined />}>Upload Pic</Button>
                </Upload>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={
                  <span className="create-user-form-label">ID Card (Back)</span>
                }
                name="idBack"
              >
                <Upload
                  onRemove={handleRemoveBack}
                  beforeUpload={handleBeforeUploadBack}
                  onChange={handleChangeBack}
                  fileList={fileListBack}
                >
                  <Button icon={<CameraOutlined />}>Upload Pic</Button>
                </Upload>
              </Form.Item>
            </Col>
          </Row> */}
            {/* Create Button Row */}
            <Row>
              <Col
                style={{ display: "flex", justifyContent: "center" }}
                span={24}
              >
                <Form.Item>
                  <NetwalaButton
                    htmlType="submit"
                    backgroundColor={ButtonProps.background.STANDARD}
                    height={ButtonProps.height.STANDARD}
                    width={ButtonProps.width.STANDARD}
                    textColor={ButtonProps.color.STANDARD}
                    onClick={() => {
                      console.log("clicked");
                    }}
                    text="Create Staff"
                    icon={<img src={PlusIcon} />}
                    disabled={isLoading}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Row>
      )}
    </>
  );
};
export default CreateStaffForm;
